import { useEffect } from "react";

export const SITE_URL = "https://bati360.com";

function setMeta(attr, key, content) {
  let el = document.querySelector(`meta[${attr}="${key}"]`);
  if (!el) {
    el = document.createElement("meta");
    el.setAttribute(attr, key);
    document.head.appendChild(el);
  }
  el.setAttribute("content", content);
}

function setLink(rel, href) {
  let el = document.querySelector(`link[rel="${rel}"]`);
  if (!el) {
    el = document.createElement("link");
    el.setAttribute("rel", rel);
    document.head.appendChild(el);
  }
  el.setAttribute("href", href);
}

export function useSEO(title, description) {
  useEffect(() => {
    const path = window.location.pathname.replace(/\/+$/, "") || "/";
    const url = SITE_URL + path;
    document.title = title;
    setMeta("name", "description", description);
    setLink("canonical", url);
    setMeta("property", "og:title", title);
    setMeta("property", "og:description", description);
    setMeta("property", "og:type", "website");
    setMeta("property", "og:url", url);
    setMeta("property", "og:site_name", "BÂTI 360");
    setMeta("property", "og:image", `${SITE_URL}/logo-full.webp`);
  }, [title, description]);
}

export function useJsonLd(data) {
  useEffect(() => {
    const script = document.createElement("script");
    script.type = "application/ld+json";
    script.id = "b360-jsonld";
    script.text = JSON.stringify(data);
    document.head.appendChild(script);
    return () => {
      const el = document.getElementById("b360-jsonld");
      if (el) el.remove();
    };
  }, []);
}
